module.exports = __webpack_public_path__ + "img/sidebar-logo.ae36330f.png";